import { MOCK_MARKERS } from '../constants';
import { SupportServiceError } from '../types';

import type { SupportService } from './support.service';

const DEFAULT_LATENCY = 700;

/**
 * TODO(DEV-4304): stand-in for POST /support/tickets until the backend is
 * ready. Always accepts (HTTP 202 equivalent) after a short delay, unless the
 * description contains a scenario marker:
 *   [mock:429] -> rate limit, [mock:500] -> server error,
 *   [mock:422] -> the first attached file is refused (content/type mismatch).
 */
export function createMockSupportService(latencyMs: number = DEFAULT_LATENCY): SupportService {
  return {
    async submitTicket(request) {
      await new Promise<void>((resolve) => {
        setTimeout(resolve, latencyMs);
      });

      const { description, files } = request;
      if (description.includes(MOCK_MARKERS.rateLimit)) {
        throw new SupportServiceError('rate_limit', 429);
      }
      if (description.includes(MOCK_MARKERS.serverError)) {
        throw new SupportServiceError('server', 500);
      }
      if (description.includes(MOCK_MARKERS.filesRejected)) {
        const first = files[0];
        throw first
          ? new SupportServiceError('files_rejected', 422, [first.name])
          : new SupportServiceError('server', 500);
      }
    },
  };
}
